<h1 class="page-title">{{ 'club.shop.title' | t }}</h1>

@if (loading && !summary) {
  <p class="muted">{{ 'account.loading' | t }}</p>
} @else if (error && !summary) {
  <p class="error-text">{{error}}</p>
  <button type="button" class="btn-pill btn-pill-outline" (click)="load()">{{ 'account.retry' | t }}</button>
} @else if (summary) {

  <section class="card shop-head">
    <div>
      <p class="intro">{{ 'club.shop.intro' | t }}</p>
      <p class="muted">{{ 'club.shop.limit' | t: { count: summary.rules.maxRedemptionsPerMonth } }}</p>
    </div>
    <div class="balance">
      <mat-icon class="coin">stars</mat-icon>
      <div>
        <strong>{{summary.available | number}}</strong>
        <span class="muted">{{ 'club.available' | t }}</span>
      </div>
    </div>
  </section>

  @if (!summary.enabled) {
    <div class="card warning">{{ 'club.closed' | t }}</div>
  }

  @if (rewards.length === 0) {
    <p class="muted">{{ 'club.shop.empty' | t }}</p>
  } @else {
    <div class="rewards-grid">
      @for (reward of rewards; track reward._id) {
        <article class="reward" [class.unavailable]="!levelAllowed(reward) || reward.stock === 0">
          <div class="reward-visual" [class]="'reward-visual type-' + reward.type">
            @if (reward.pictureUrl) {
              <img [src]="reward.pictureUrl" [appImgFallback]="reward.storedPictureUrl" [alt]="reward.name" loading="lazy" />
            } @else {
              <mat-icon>{{ reward.type === 'giftCard' ? 'card_giftcard' : reward.type === 'perk' ? 'auto_awesome' : 'redeem' }}</mat-icon>
              @if (reward.valueEuro) { <span class="value">{{reward.valueEuro}} €</span> }
            }
          </div>
          <div class="reward-body">
            <span class="chip">{{ 'club.shop.types.' + reward.type | t }}</span>
            <strong class="reward-name">{{reward.name}}</strong>
            @if (reward.description) { <p class="muted">{{reward.description}}</p> }
            <div class="reward-meta">
              <span class="cost"><mat-icon>stars</mat-icon>{{reward.costPoints | number}}</span>
              @if (reward.stock !== null && reward.stock > 0) {
                <small class="muted">{{ 'club.shop.stockLeft' | t: { count: reward.stock } }}</small>
              }
            </div>
            @if (levelAllowed(reward) && reward.stock !== 0 && missingPoints(reward) > 0) {
              <div class="progress"><span [style.width.%]="progress(reward)"></span></div>
              <small class="muted">{{ 'club.shop.missing' | t: { points: missingPoints(reward) } }}</small>
            }
            @if (!levelAllowed(reward)) {
              <span class="locked"><mat-icon>lock</mat-icon>{{ 'club.shop.requiresLevel' | t: { level: ('club.levels.' + reward.minLevel | t) } }}</span>
            } @else if (reward.stock === 0) {
              <span class="locked"><mat-icon>inventory_2</mat-icon>{{ 'club.shop.outOfStock' | t }}</span>
            } @else {
              <button type="button" class="btn-pill btn-pill-accent" [disabled]="!canRedeem(reward)" (click)="redeem(reward)">
                {{ (redeemingId === reward._id ? 'club.shop.redeeming' : 'club.shop.redeem') | t }}
              </button>
            }
          </div>
        </article>
      }
    </div>
  }

  <section class="card">
    <h2 class="card-title">{{ 'club.shop.myRewards' | t }}</h2>
    @if (redemptions.length === 0) {
      <p class="muted">{{ 'club.shop.myRewardsEmpty' | t }}</p>
    } @else {
      <ul class="redemptions">
        @for (redemption of redemptions; track redemption._id) {
          <li>
            <div class="redemption-text">
              <strong>{{redemption.rewardName}}</strong>
              <small class="muted">{{ date(redemption.createdAt) }} · {{ 'club.shop.cost' | t: { points: redemption.costPoints } }}</small>
              @if (redemption.status === 'fulfilled' && redemption.code) {
                <div class="code">
                  <span class="muted">{{ 'club.shop.code' | t }}</span>
                  @if (isLink(redemption.code)) {
                    <a [href]="redemption.code" target="_blank" rel="noopener">{{redemption.code}}</a>
                  } @else {
                    <code>{{redemption.code}}</code>
                  }
                  <button type="button" class="btn-text" (click)="copy(redemption.code)">{{ 'club.shop.copy' | t }}</button>
                </div>
              }
              @if (redemption.adminNote) { <small class="muted">{{redemption.adminNote}}</small> }
            </div>
            <span [class]="'chip ' + redemption.status">{{ 'club.shop.status.' + redemption.status | t }}</span>
          </li>
        }
      </ul>
    }
  </section>
}
